export const CAMPAIGNS_OPTIONS = 'CAMPAIGNS_OPTIONS';
export const CAMPAIGNS = 'CAMPAIGNS';
export const SEQUENCES = 'SEQUENCES';
export const GENERAL_ERRORS = 'GENERAL_ERRORS';
export const GENERAL_ERRORS_APPEND = 'GENERAL_ERRORS_APPEND';
export const RESET = 'RESET';
